import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { getStyled } from "@sf-core";

const PowerBiEmbed = ({ url }) => {
  const { styled } = getStyled();

  const StyledFrame = useMemo(() =>
    styled("iframe")(
      () => ({
        width: "100%",
        height: "100%",
        border: 0,
      }),
      []
    )
  );
  return <StyledFrame src={url}></StyledFrame>;
};

PowerBiEmbed.propTypes = {
  url: PropTypes.string.isRequired,
};

export default PowerBiEmbed;
